import { useEffect } from "react";
import { MainLayout, SectionLayout } from "../layouts";
import { BannerPage } from "../components";
import { useLocation } from "react-router-dom";

const SECTIONS = [
  {
    title: "1. Penerimaan Syarat & Ketentuan",
    content: `Dengan mengakses dan menggunakan situs web Pendidikan Pesantren Idrisiyyah Tasikmalaya, Anda menyatakan telah membaca, memahami, dan menyetujui untuk terikat pada Syarat & Ketentuan ini beserta Kebijakan Privasi kami. Apabila Anda tidak menyetujui salah satu ketentuan yang berlaku, kami sarankan untuk tidak melanjutkan penggunaan situs web ini.`,
  },
  {
    title: "2. Penggunaan Situs Web",
    content: `Situs web ini disediakan untuk memberikan informasi seputar kegiatan pendidikan, akademik, berita, dan publikasi resmi Pendidikan Pesantren Idrisiyyah Tasikmalaya. Anda setuju untuk menggunakan situs ini hanya untuk tujuan yang sah dan tidak melanggar hukum, tidak merugikan pihak lain, serta tidak mengganggu jalannya operasional situs web.`,
  },
  {
    title: "3. Hak Kekayaan Intelektual",
    content: `Seluruh konten yang terdapat pada situs web ini, termasuk namun tidak terbatas pada teks, gambar, logo, grafis, dan tata letak, merupakan milik Pendidikan Pesantren Idrisiyyah Tasikmalaya atau pihak ketiga yang memberikan lisensi kepada kami, serta dilindungi oleh hukum hak cipta yang berlaku. Dilarang menyalin, mendistribusikan, atau menggunakan konten tersebut untuk kepentingan komersial tanpa izin tertulis dari kami.`,
  },
  {
    title: "4. Akurasi Informasi",
    content: `Kami berupaya menyajikan informasi yang akurat dan terkini pada situs web ini. Namun, kami tidak menjamin bahwa seluruh informasi yang ditampilkan selalu bebas dari kesalahan atau kekurangan. Informasi dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya, dan kami tidak bertanggung jawab atas kerugian yang timbul akibat penggunaan informasi tersebut.`,
  },
  {
    title: "5. Tautan ke Situs Pihak Ketiga",
    content: `Situs web ini dapat memuat tautan menuju situs pihak ketiga untuk kemudahan pengguna. Kami tidak bertanggung jawab atas konten, kebijakan privasi, atau praktik yang diterapkan oleh situs pihak ketiga tersebut. Akses terhadap situs pihak ketiga sepenuhnya menjadi risiko dan tanggung jawab pengguna.`,
  },
  {
    title: "6. Batasan Tanggung Jawab",
    content: `Pendidikan Pesantren Idrisiyyah Tasikmalaya tidak bertanggung jawab atas kerugian langsung maupun tidak langsung yang timbul akibat penggunaan atau ketidakmampuan mengakses situs web ini, termasuk namun tidak terbatas pada gangguan teknis, kehilangan data, atau kerugian lain di luar kendali kami.`,
  },
  {
    title: "7. Perubahan Layanan dan Ketentuan",
    content: `Kami berhak untuk mengubah, menangguhkan, atau menghentikan sebagian maupun seluruh layanan pada situs web ini, serta memperbarui Syarat & Ketentuan ini sewaktu-waktu sesuai kebutuhan. Perubahan akan berlaku efektif sejak dipublikasikan pada halaman ini.`,
  },
  {
    title: "8. Hukum yang Berlaku",
    content: `Syarat & Ketentuan ini diatur dan ditafsirkan berdasarkan hukum yang berlaku di Republik Indonesia. Segala perselisihan yang timbul sehubungan dengan penggunaan situs web ini akan diselesaikan secara musyawarah untuk mufakat, dan apabila diperlukan, melalui jalur hukum yang berlaku.`,
  },
  {
    title: "9. Kontak Kami",
    content: `Jika Anda memiliki pertanyaan mengenai Syarat & Ketentuan ini, silakan hubungi kami melalui kontak resmi yang tersedia pada situs web Pendidikan Pesantren Idrisiyyah Tasikmalaya.`,
  },
];

export default function SyaratKetentuan() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <MainLayout title="Syarat & Ketentuan - Pesantren Idrisiyyah">
      <BannerPage
        title="Syarat & Ketentuan"
        subtitle="Ketentuan penggunaan layanan dan situs web kami"
      />

      <SectionLayout title="Syarat & Ketentuan">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-sm border border-neutral-100 dark:border-neutral-700 p-8 md:p-12">
            <p className="text-neutral-500 dark:text-neutral-400 text-sm mb-8">
              Terakhir diperbarui: 22 Juli 2026
            </p>

            <p className="text-neutral-600 dark:text-neutral-300 leading-relaxed text-justify mb-10">
              Selamat datang di situs web Pendidikan Pesantren Idrisiyyah
              Tasikmalaya. Syarat & Ketentuan berikut mengatur penggunaan Anda
              atas situs web ini. Dengan mengakses dan menggunakan situs web
              ini, Anda dianggap telah menyetujui seluruh ketentuan yang
              tercantum di bawah ini.
            </p>

            <div className="space-y-8">
              {SECTIONS.map((section, idx) => (
                <div
                  key={idx}
                  className="pb-8 border-b border-neutral-100 dark:border-neutral-700 last:border-0 last:pb-0"
                >
                  <h2 className="text-lg font-bold text-idi-700 dark:text-idi-400 mb-3">
                    {section.title}
                  </h2>
                  <p className="text-neutral-600 dark:text-neutral-300 leading-relaxed text-justify">
                    {section.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </SectionLayout>
    </MainLayout>
  );
}
